/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WelcomeInputs */



/**
* | output |
* | --- |
* | "Welcome" |
*
* @param {WelcomeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const welcome = /** @type {((inputs?: WelcomeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WelcomeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bienvenue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Willkommen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Benvenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добро пожаловать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bienvenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("欢迎")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いらっしゃいませ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वागत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bem-vindo")
	return /** @type {LocalizedString} */ ("Welcome")
});